<template>
  <el-drawer style="border-radius: 20px"
      destroy-on-close
      :modal="false"
      size="540px"
      direction="btt"
      :visible.sync="show"
      v-bind="$attrs"
      v-on="$listeners"
      @close="handleCancel"
  >
    <div class="apply-title">
      <div class="el-icon-back" style="font-weight: bold;margin-top: 4px" @click="handleCancel"></div>
      <div>转办他人</div>
      <div></div>
    </div>
    <div style="padding: 10px 16px;margin-top: 20px">
    <el-form
      v-loading="loading"
      ref="formRef"
      :model="formValue"
      :rules="rules">
      <el-form-item label="转办人" prop="transferUserInfo" required>
        <el-button v-if="!transferUserInfoUserName" size="mini" @click="handleShowOrgPicker"> 选择人员</el-button>
        <el-tag @click="handleShowOrgPicker"
          v-if="transferUserInfoUserName"
          :style="{ marginLeft: '10px' }"
          size="small"
          >{{ transferUserInfoUserName }}</el-tag
        >
      </el-form-item>
      <el-form-item label="转办说明" prop="comments" required>
        <el-input
          type="textarea"
          v-model="formValue.comments"
          placeholder="请输入"
          maxlength="255"
          rows="4"
          show-word-limit
        />
      </el-form-item>
      <el-form-item>
        <image-upload v-model="formValue.imageList" />
      </el-form-item>
<!--      <el-form-item>-->
<!--        <file-upload v-model="formValue.fileList" />-->
<!--      </el-form-item>-->
    </el-form>
    </div>
    <div style="position: fixed;bottom: 16px;left: 50%;transform: translateX(-50%)">
      <el-button style="background-color: #409EFF;color: white;border-radius: 14px;padding: 15px 40px;border: none"
                 :loading="loading"
                 @click="handleConfirm"
      >转 办</el-button>
    </div>
    <dynamic-picker
        type="user"
        ref="orgPicker"
        :selected="formValue.transferUserInfo ? [formValue.transferUserInfo] : []"
        @ok="handleSelectedOrg"
    />
  </el-drawer>
</template>

<script>
import DynamicPicker from "@/components/common/DynamicPicker";
import ImageUpload from "./ImageUpload";
import FileUpload from "./FileUpload";
import { assignee } from "@/api/design";

export default {
  name: "AssigneeModal",
  components: {  ImageUpload, FileUpload ,DynamicPicker},
  props: {
    // 是否显示
    visible: {
      type: Boolean,
      default: false,
    },
    processInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      formValue: {
        comments: "",
        transferUserInfo: null,
        imageList: [],
        fileList: [],
      },
      rules: {
        transferUserInfo: [
          { required: true, message: "请选择转办人", trigger: "change" },
        ],
        comments: [
          { required: true, message: "请说明原因", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(visible) {
        this.$emit("update:visible", visible);
      },
    },
    // 用户名展示
    transferUserInfoUserName() {
      return this.formValue.transferUserInfo?.name || "";
    },
  },
  methods: {
    // 确认操作
    handleConfirm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        const { imageList, fileList, ...restParams } = this.formValue;
        const params = {
          ...this.processInfo,
          ...restParams,
          attachments: [...imageList, ...fileList],
        };
        this.loading = true;
        assignee(params)
          .then(() => {
            this.$message.success("转办成功");
            this.handleCancel();
            this.$emit("success");
            this.$router.back(0);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    // 取消操作
    handleCancel() {
      this.$emit('cancel');
      this.$refs.formRef.resetFields();
      this.formValue = {
        comments: "",
        transferUserInfo: null,
        imageList: [],
        fileList: [],
      };
      this.show = false;
    },
    // 显示用户选择器
    handleShowOrgPicker() {
      this.$refs.orgPicker.show();
    },
    // 选择用户确认操作
    handleSelectedOrg(selected) {
      if (!selected.length) {
        this.formValue.transferUserInfo = null;
        return;
      }
      if (selected[0].id === this.processInfo.currentUserInfo.id) {
        this.$message.error("转办人不能给自己");
        return;
      }
      this.formValue.transferUserInfo = selected[0];
    },
  },
};
</script>
<style scoped>
.apply-title{
  font-weight: bold;
  font-size: 15px;
  position: absolute;
  top: 58px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  padding: 0 20px;
  align-content: center;
  display: flex;
  justify-content: space-between;
}
</style>